import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { Link } from '@ps/web-shared-components';
import React from 'react';

import type { Category } from '../types';

export const getCategoryTitle = (categories: Category[], currentId: string) =>
  categories?.filter(({ id }) => currentId === id)[0]?.title || '';

export const getSideNavs = (categories: Category[]) =>
  categories?.map(({ id, title }) => ({
    id,
    element: (
      <Link alias="helpCenterCategoryArticles" values={{ category: id }}>
        {title}
      </Link>
    )
  })) || [];

export const LicenseNames = {
  [LicenceId.DEFAULT]: 'COM',
  [LicenceId.ITALY]: 'IT',
  [LicenceId.FRANCE]: 'FR',
  [LicenceId.ESTONIA]: 'EE',
  [LicenceId.BELGIUM]: 'BE',
  [LicenceId.SPAIN]: 'ES',
  [LicenceId.DENMARK]: 'DK',
  [LicenceId.EU]: 'EU',
  [LicenceId.UK]: 'UK',
  [LicenceId.BG]: 'BG',
  [LicenceId.DESH]: 'DESH',
  [LicenceId.ROMANIA]: 'RO',
  [LicenceId.PORTUGAL]: 'PT',
  [LicenceId.CZ]: 'CZ',
  [LicenceId.INDIA]: 'IN',
  [LicenceId.ASIA]: 'ASIA',
  [LicenceId.RU]: 'RU',
  [LicenceId.SE]: 'SE',
  [LicenceId.CH]: 'CH',
  [LicenceId.NL]: 'NL',
  [LicenceId.CAON]: 'CAON',
  [LicenceId.GR]: 'GR',
  [LicenceId.DE]: 'DE',
  [LicenceId.USCO]: 'USCO',
  [LicenceId.USNJ]: 'USNJ',
  [LicenceId.USPA]: 'USPA',
  [LicenceId.USMI]: 'USMI',
  [LicenceId.IT_SISAL_EXT]: 'SISAL',
  [LicenceId.PORTUGAL_OLD]: 'PORTUGAL_OLD',
  [LicenceId.ARBA]: 'ARBA',
  [LicenceId.FB]: 'FB',
  [LicenceId.LICENCE_DEFAULT_BIT_FOR_MASK_USE_ONLY]: 'LICENCE_DEFAULT_BIT_FOR_MASK_USE_ONLY',
  [LicenceId.ES_PS_EXT]: 'ES_PS_EXT',
  [LicenceId.FR_PS_EXT]: 'FR_PS_EXT',
  [LicenceId.PT_PS_EXT]: 'PT_PS_EXT',
  [LicenceId.IT_PS_EXT]: 'IT_PS_EXT',
  [LicenceId.UK_PS_EXT]: 'UK_PS_EXT',
  [LicenceId.COM_PS_EXT]: 'COM_PS_EXT',
  [LicenceId.DE_PS_EXT]: 'DE_PS_EXT',
  [LicenceId.EE_PS_EXT]: 'EE_PS_EXT',
  [LicenceId.UNDEFINED]: 'UNDEFINED',
  [LicenceId.SHARED_LIQUDITY_POOL]: 'SHARED_LIQUDITY_POOL'
};

const MIAWLocale = {
  en: 'en',
  cs: 'cs',
  da: 'da',
  de: 'de',
  el: 'el',
  es: 'es',
  'es-419': 'es_MX',
  et: 'et',
  fr: 'fr',
  hr: 'hr',
  it: 'it',
  lv: 'lv',
  lt: 'lt',
  hu: 'hu',
  nl: 'nl_NL',
  no: 'no',
  pl: 'pl',
  pt: 'pt_PT',
  'pt-BR': 'pt_BR',
  ro: 'ro',
  sl: 'sl',
  sk: 'sk',
  sv: 'sv',
  fi: 'fi',
  bg: 'bg',
  ru: 'ru',
  uk: 'uk',
  ja: 'ja',
  'zh-CN': 'zh_CN',
  'zh-TW': 'zh_TW',
  ko: 'ko',
  is: 'is',
  vi: 'vi',
  ca: 'ca',
  kl: 'kl'
};

export const toMIAWLocale = (locale: string) =>
  MIAWLocale[locale as keyof typeof MIAWLocale] ?? 'en';
